import React from 'react';
import Field from './Field';
import Grid from '@mui/material/Grid2';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

export default function DropdownField(props) {
  const { question, tooltip, options, answer, updateAnswer, xs, sm, primarycolor } = props;

  const isError = answer === "";

  const errorSx = {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'red'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'red'
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'red'
    }
  };

  const primarySx = {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: primarycolor
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: primarycolor
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: primarycolor
    }
  };

  const handleSelectChange = (event) => {
    updateAnswer(event.target.value);
  };

  return (
    <Field question={question} tooltip={tooltip}>
      <Grid size={12}>
        <FormControl fullWidth variant="outlined" error={isError}>
          <InputLabel id={`dropdown-label-${question}`}>Select</InputLabel>
          <Select
            labelId={`dropdown-label-${question}`}
            value={answer}
            onChange={handleSelectChange}
            label="Select"
            sx={ isError ? errorSx : primarycolor ? primarySx : {} }
          >
            {options.map((option, index) => (
              <MenuItem value={option.value} key={index}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Field>
  );
}
